module.exports = __webpack_public_path__ + "img/explorerchallenge.a479bf47.png";